import { createContext, useContext, useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fitsmith_token");
    if (!token) { setLoading(false); return; }
    fetch(`${API}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(u => { if (u) setUser({ ...u, token }); else localStorage.removeItem("fitsmith_token"); })
      .catch(() => localStorage.removeItem("fitsmith_token"))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (email, password) => {
    const r = await fetch(`${API}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password })
    });
    if (!r.ok) {
      let msg = "Ongeldig e-mailadres of wachtwoord";
      try { const d = await r.json(); if (d.detail) msg = d.detail; } catch {}
      throw new Error(msg);
    }
    const data = await r.json();
    localStorage.setItem("fitsmith_token", data.token);
    setUser({ ...data.user, token: data.token, has_password: data.has_password });
    return data;
  };

  const loginWithToken = (userData, token) => {
    localStorage.setItem("fitsmith_token", token);
    setUser({ ...userData, token });
  };

  const logout = () => {
    localStorage.removeItem("fitsmith_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
